import React from 'react'
import { NewSidebar } from './NewSidebar/NewSidebar'

export type SidebarProps = {
  hidden?: boolean
}

export const Sidebar = ({ hidden }: SidebarProps) => {
  return <NewSidebar hidden={hidden} />
}
